type DiffResult = {
  [key: string]: DiffResult | { from: any; to: any };
};

export const isEqual = (a: any, b: any) => {
    return JSON.stringify(a) === JSON.stringify(b)
}

export const diffObjects = (obj1: any, obj2: any): DiffResult => {
  const seen = new WeakSet();

  function _diff(o1: any, o2: any): DiffResult {
    if (seen.has(o1) || seen.has(o2)) return {};
    if (typeof o1 === "object" && o1 !== null) seen.add(o1);
    if (typeof o2 === "object" && o2 !== null) seen.add(o2);

    const result: DiffResult = {};
    const keys = new Set([...Object.keys(o1 || {}), ...Object.keys(o2 || {})]);

    keys.forEach(key => {
      const val1 = o1 ? o1[key] : undefined;
      const val2 = o2 ? o2[key] : undefined;

      if (Array.isArray(val1) && Array.isArray(val2)) {
        // Compare arrays by value
        if (
          val1.length !== val2.length ||
          val1.some((v, i) => v !== val2[i])
        ) {
          result[key] = { from: val1, to: val2 };
        }
      } else if (
        typeof val1 === "object" &&
        val1 !== null &&
        typeof val2 === "object" &&
        val2 !== null
      ) {
        const nestedDiff = _diff(val1, val2);
        if (Object.keys(nestedDiff).length > 0) result[key] = nestedDiff;
      } else if (val1 !== val2) {
        result[key] = { from: val1, to: val2 };
      }
    });

    return result;
  }

  return _diff(obj1, obj2);
}